import { render } from "./Anotherproduct.vue?vue&type=template&id=a9fab7e0"
import script from "./Anotherproduct.vue?vue&type=script&lang=js"
export * from "./Anotherproduct.vue?vue&type=script&lang=js"

import "./Anotherproduct.vue?vue&type=style&index=0&id=a9fab7e0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__